import * as React from 'react';
import aiLogo from './ai-logo.png';

type AiAvatarSize = 'sm' | 'lg' | 'icon';

const sizeMap: Record<AiAvatarSize, string> = {
  sm: '1.75rem',
  lg: '3rem',
  icon: '14px',
};

type Props = {
  size: AiAvatarSize;
};

const AiAvatar: React.FC<React.PropsWithChildren<Props>> = ({ size }) => (
  <img
    src={aiLogo}
    alt="AI"
    style={{ width: sizeMap[size], height: sizeMap[size], flexShrink: 0 }}
  />
);

export default AiAvatar;
